import React from 'react';
import { every } from 'lodash';
import { Button } from 'ui';
import JoinVideoMeetingButton from 'components/InPersonTraining/shared/JoinVideoMeetingButton';
import RSVPButtons from './RSVPButtons';
import AddToCalendar from './AddToCalendar';

const AttendanceForm = ({
  attendance,
  event,
  session,
  pastEvent,
  setUserAttendance,
  changeAttendance,
  statusLoading,
  canChangeAttendance,
  showSessionAtCapacityNotice,
  showRsvpButtons,
  showAddToCalendar,
}) => (
  <div>
    {showRsvpButtons && (
      <RSVPButtons
        pastEvent={pastEvent}
        setUserAttendance={setUserAttendance}
        statusLoading={statusLoading}
      />
    )}
    {!showRsvpButtons && (
      <JoinVideoMeetingButton
        className="Button mr-12"
        rsvpStatus={attendance.status}
        session={session}
        event={event}
      />
    )}
    {!showRsvpButtons && canChangeAttendance && !showSessionAtCapacityNotice && (
      <Button type="button" onClick={changeAttendance} className="mr-12">
        {t('in_person_training.rsvp_details.change_rsvp')}
      </Button>
    )}
    {!showRsvpButtons && showAddToCalendar && (
      <AddToCalendar className="mr-12" event={event} session={session} />
    )}
  </div>
);

export default props => {
  const {
    attendance,
    session,
    pastEvent,
    changingAttendance,
    canChangeAttendance,
  } = props;

  // User can register or chnage their RSVP status
  const neverRegistered = every([
    attendance.did_attend === null,
    attendance.rsvp_status === null,
    !pastEvent || canChangeAttendance,
  ]);

  // Session has a max attendance set and session is at capacity
  const sessionIsAtCapacity = every([
    session.max_attendees !== null,
    session.total_registered >= session.max_attendees,
  ]);

  // User has not registered and session is at capacity
  const showSessionAtCapacityNotice = every([
    !pastEvent || canChangeAttendance,
    !(attendance.did_attend || attendance.rsvp_status === 'will_attend'),
    sessionIsAtCapacity,
  ]);

  // User can register or change their attendance status
  const showRsvpButtons = every([
    neverRegistered || changingAttendance,
    !showSessionAtCapacityNotice,
  ]);

  return (
    <AttendanceForm
      {...props}
      showSessionAtCapacityNotice={showSessionAtCapacityNotice}
      showRsvpButtons={showRsvpButtons}
      showAddToCalendar={attendance.rsvp_status === 'will_attend' && !pastEvent}
    />
  );
};
